import { render, staticRenderFns } from "./FormDesignRender1.vue?vue&type=template&id=05d54338&scoped=true&"
import script from "./FormDesignRender1.vue?vue&type=script&lang=js&"
export * from "./FormDesignRender1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d54338",
  null
  
)

export default component.exports